export enum Game {
	OVERWATCH = 'OVERWATCH',
	MARVEL_RIVALS = 'MARVEL_RIVALS',
}
